import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { EventTypes, ToastEvent } from '../../../components/toaster';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toastEvents: Observable<ToastEvent>;
  private _toastEvents = new Subject<ToastEvent>();

  constructor() {
    this.toastEvents = this._toastEvents.asObservable();
  }

  showToast(message: string, type: EventTypes, delay?: number) {
    this._toastEvents.next({
      message,
      type: type,
      delay: delay,
    });
  }

  /**
   * Show success toast notification.
   * @param message Toast message
   */
  showSuccessToast(message: string, delay?: number) {
    this.showToast(message, EventTypes.Success, delay);
  }

  /**
   * Show info toast notification.
   * @param message Toast message
   */
  showInfoToast(message: string, delay?: number) {
    this.showToast(message, EventTypes.Info, delay);
  }

  /**
   * Show warning toast notification.
   * @param message Toast message
   */
  showWarningToast(message: string, delay?: number) {
    this.showToast(message, EventTypes.Warning, delay);
  }

  /**
   * Show error toast notification.
   * @param message Toast message
   */
  showErrorToast(message: string, delay?: number) {
    this.showToast(message, EventTypes.Error, delay);
  }
}
